import React, { useEffect } from 'react';
import styled from 'styled-components';

import { BookLayoutEnum } from '~/api/book/bookApiTypes';
import { TextRegStyle } from '~/atomic/Typography';
import {
  changeSavedLayout,
  loadGenreLayout,
} from '~/feature/catalog/CatalogBookLayout/CatalogBookLayout.data';
import { catalogBookLayoutSelector } from '~/feature/catalog/CatalogBookLayout/catalogBookLayout.selector';
import { BookLayout } from '~/feature/catalog/filter/BookLayout';
import { environments } from '~/lib/const';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

interface CatalogBookLayoutProps {
  booksTotal: number;
}

export const CatalogBookLayout = ({ booksTotal }: CatalogBookLayoutProps) => {
  const dispatch = useAppDispatch();
  const { layout } = useAppSelector(catalogBookLayoutSelector);

  const onChangeLayoutHandler = (newLayout: BookLayoutEnum) => {
    dispatch(changeSavedLayout(newLayout));
  };

  useEffect(() => {
    if (!environments.isClient) return;
    dispatch(loadGenreLayout());
  }, [dispatch]);

  return (
    <SCBookLayout>
      <SCBookSortWrapper>
        <SCBooksTotal>{`Книг всего: ${booksTotal}`}</SCBooksTotal>
      </SCBookSortWrapper>
      <BookLayout layout={layout} onChangeLayout={onChangeLayoutHandler} />
    </SCBookLayout>
  );
};

const SCBookSortWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SCBooksTotal = styled.span`
  ${TextRegStyle};
  margin-right: 40px;

  color: var(--black-color);
`;

const SCBookLayout = styled.div`
  width: 100%;
  margin-bottom: 16px;
  margin-right: auto;
  margin-left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${lessThan('sm')} {
    margin-bottom: 8px;
  }
`;
